import { TeaBlocksError } from './../../TeaBlocksError';
import { ShapeColor } from './ShapeColor';
import { ReturnBlock } from "../ReturnBlock";
import { VoidBlock } from "../VoidBlock";
import { Shape } from "./Shape";
import { ShapeType } from "./ShapeType";

/**
 * Creates variable parameters for some shape
 */
export class MakeShapeBlock extends VoidBlock {
    shapeName: ReturnBlock;
    color: ShapeColor;
    shapeType: ShapeType;
    posX: ReturnBlock;
    posY: ReturnBlock;
    scaleX: ReturnBlock;
    scaleY: ReturnBlock;
    rot: ReturnBlock;

    /**
     * Constructor
     * 
     * @param id the id
     * @param shapeType the type of the shape
     * @param color the color of the shape.
     * @param inputs inputs
     */
    constructor(id:string, shapeType: ShapeType, color: ShapeColor,
        inputs: ReturnBlock[]) {
        super(id);
        this.shapeType = shapeType;
        this.color = color;

        console.log(inputs);

        this.shapeName = inputs[0];
        this.posX = inputs[1];
        this.posY = inputs[2];
        this.scaleX = inputs[3];
        this.scaleY = inputs[4];
        this.rot = inputs[5];
    }

    /**
     * Creates variable array for new shape
     * @param varEnv variable environment
     */
    *evalBlock(varEnv: Map<string, any>) {
        let shapeName = String(this.shapeName.evalBlock(varEnv));
        let posx = Number(this.posX.evalBlock(varEnv));
        let posy = Number(this.posY.evalBlock(varEnv));
        let scalex = Number(this.scaleX.evalBlock(varEnv));
        let scaley = Number(this.scaleY.evalBlock(varEnv));
        let rot = Number(this.rot.evalBlock(varEnv));

        console.log(shapeName);
        console.log(posx);
        console.log(posy);
        console.log(scalex);
        console.log(scaley);
        console.log(rot);

        if (isNaN(posx) ||
            isNaN(posy) ||
            isNaN(scalex) ||
            isNaN(scaley) ||
            isNaN(rot)) {
            throw new TeaBlocksError("Shape input not a number", this.id);
        }

        varEnv.set('$' + shapeName, new Shape(shapeName, this.shapeType, this.color, posx, posy, scalex, scaley, rot));
        yield;
    }
}